import { colorLookup } from '@medifind/utils';
import { SVG } from './SVG';
const IconPhoneFill = ({ color = '#fff', size = 16 }) => {
  const colorCode = colorLookup(color) ?? colorLookup('blue');
  return (
    <SVG width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.7777 13.3046L13.5219 15.5423C13.1889 15.8838 12.7475 15.9995 12.3176 16C10.4167 15.943 8.61987 15.0093 7.14456 14.0505C4.72294 12.2887 2.50099 10.1043 1.10646 7.46442C0.571602 6.35745 -0.0559709 4.94504 0.00398907 3.70945C0.00933573 3.24465 0.134589 2.78848 0.461936 2.48888L2.71775 0.234198C3.18618 -0.164242 3.63918 -0.0264819 3.93894 0.437625L5.75375 3.87898C5.94476 4.28668 5.83519 4.7235 5.5502 5.01482L4.71911 5.84549C4.6678 5.91577 4.63514 5.99577 4.63431 6.08284C4.953 7.31646 5.91848 8.45349 6.77139 9.23598C7.62428 10.0185 8.54106 11.0786 9.73108 11.3296C9.87818 11.3706 10.0583 11.385 10.1636 11.2872L11.1304 10.304C11.4637 10.0514 11.9449 9.9279 12.3007 10.1344H12.3176L15.5911 12.067C16.0716 12.3682 16.1217 12.9504 15.7777 13.3046Z"
        fill={colorCode}
      />
    </SVG>
  );
};

export { IconPhoneFill as default, IconPhoneFill };
